/**
 * Module-level support preview flag.
 * Set by SupportPreviewContext, read by MutationCache guard.
 * This avoids prop-drilling through every mutation hook.
 */
let _active = false;

export function setSupportPreviewActive(value: boolean) {
  _active = value;
}

export function isSupportPreviewActive(): boolean {
  return _active;
}

/**
 * Error thrown when a mutation is blocked by support preview.
 * Identifiable by name for catch handlers.
 */
export class SupportPreviewBlockedError extends Error {
  constructor() {
    super('Ändringar är inte tillåtna i supportläge.');
    this.name = 'SupportPreviewBlockedError';
  }
}

/**
 * Throws if support preview is active.
 * Used by MutationCache.onMutate to centrally block all mutations.
 */
export function assertNotSupportPreview() {
  if (_active) {
    throw new SupportPreviewBlockedError();
  }
}
